var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "upload_a_picture_create_invitation",
    "data-name": "upload a picture_create invitation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M26.381,29.952H5.048V8.619H18.762V5.571H5.048A3.057,3.057,0,0,0,2,8.619V29.952A3.057,3.057,0,0,0,5.048,33H26.381a3.057,3.057,0,0,0,3.048-3.048V16.238H26.381Zm-11.87-4.83-2.987-3.6L7.333,26.9H24.1L18.7,19.728ZM29.428,5.571V1H26.381V5.571H21.809c.015.015,0,3.048,0,3.048h4.571v4.556c.015.015,3.048,0,3.048,0V8.619H34V5.571Z",
    transform: "translate(-2 -1)",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPicture);
export default __webpack_public_path__ + "static/media/upload_picture.2fc45e9c765572c7e1b73efee0dfef76.svg";
export { ForwardRef as ReactComponent };